import { useElementSize } from '@mantine/hooks'
import { Stack } from '@mui/material'
import { nanoid } from 'nanoid'
import { useLocation } from 'react-router-dom'

import ScrollToElement from '~/components/scrollToElement'
import DialogInput from '~/features/chatbot/components/dialog/dialogInput'
import Message from '~/features/chatbot/components/message'
import {
  TEMPLATE_PAGE_CHAT_KEY,
  TEMPLATE_PAGE_CHAT_VALUE,
} from '~/features/chatbot/constants'
import { EChatbotTheme } from '~/features/settings/models'
import useGetElementDimensions from '~/features/ui/hooks/useGetElementDimensions'
import EElement from '~/features/ui/models'
import { store } from '~/store'
import rem from '~/utils/ui'

function Dialog() {
  const { ref: dialogInputRef, height: dialogInputHeight } = useElementSize()
  const { height: layoutFooterHeight } = useGetElementDimensions(
    EElement.chatbotFooter,
  )
  const { height: headerHeight } = useGetElementDimensions(
    EElement.chatbotHeader,
  )

  const [chatbotLayout, messages] = store((state) => [
    state.chatbot.layout,
    state.chatbot.messages,
  ])

  const location = useLocation()
  const isChatbotOnTemplatePage =
    new URLSearchParams(location.search).get(TEMPLATE_PAGE_CHAT_KEY) ===
    TEMPLATE_PAGE_CHAT_VALUE

  return (
    <Stack
      sx={{
        width: {
          xxxs: '100%',
          md:
            chatbotLayout.selection.theme === EChatbotTheme.simple
              ? '70%'
              : '100%',
        },
        flexGrow: 1,
        height: '100%',
        overflow: 'hidden',
      }}
    >
      <Stack
        gap={2}
        sx={{
          gap: 2,
          paddingInline: 2,
          paddingTop: 2,
          overflowY: 'auto',
          '& > div:first-of-type': {
            marginTop: 'auto',
          },
          overflowAnchor: 'auto',
          height: '100%',
          flex: 1,
          marginTop: { xxxs: rem(headerHeight), md: 0 },
          maxHeight: {
            xxxs: `calc(100vh - ${rem(headerHeight)} - ${rem(dialogInputHeight)} - ${rem(layoutFooterHeight)})`,
            md: '100%',
          },
          minHeight: {
            xxxs: `calc(100vh  -  ${rem(headerHeight)} - ${rem(dialogInputHeight)} - ${rem(layoutFooterHeight)})`,
            md: '100%',
          },
          justifyContent: !isChatbotOnTemplatePage ? 'initial' : 'flex-end',
          '& iframe': {
            border: 'none',
          },
        }}
      >
        {messages.map((dialog, index) => (
          <Message
            key={nanoid()}
            speaker={dialog.speaker}
            message={dialog.message}
            isFirst={index === 0}
          />
        ))}
        {!isChatbotOnTemplatePage && <ScrollToElement />}
      </Stack>
      <DialogInput ref={dialogInputRef} />
    </Stack>
  )
}

export default Dialog
